import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import VideocamIcon from "@mui/icons-material/Videocam";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CallMissedIcon from "@mui/icons-material/CallMissed";
import CallEndIcon from "@mui/icons-material/CallEnd";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";

const CallMessage = ({ message, currentUserId }) => {
  if (!message.callData) return null;

  const { callData, sender, createdAt } = message;
  const { type, status, duration, initiator } = callData;

  const isInitiator = initiator?._id === currentUserId;
  const isIncoming = !isInitiator;

  const formatDuration = (seconds) => {
    if (!seconds || seconds === 0) return null;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins === 0) return `${secs}s`;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const CallTypeIcon = type === "video" ? VideocamIcon : PhoneIcon;

  const getCallStatusInfo = () => {
    switch (status) {
      case "completed":
        return {
          icon: isIncoming ? CallReceivedIcon : CallMadeIcon,
          text: isIncoming ? "Incoming call" : "Outgoing call",
          color: "text-green-600",
          bgColor: "bg-green-50",
          borderColor: "border-green-200",
          showDuration: true,
        };
      case "missed":
        return {
          icon: PhoneMissedIcon,
          text: isInitiator ? "Cancelled call" : "Missed call",
          color: "text-red-600",
          bgColor: "bg-red-50",
          borderColor: "border-red-200",
          showDuration: false,
        };
      case "rejected":
        return {
          icon: CallEndIcon,
          text: isIncoming ? "Rejected call" : "Call declined",
          color: "text-red-600",
          bgColor: "bg-red-50",
          borderColor: "border-red-200",
          showDuration: false,
        };
      case "cancelled":
        return {
          icon: CallMissedIcon,
          text: isInitiator ? "Cancelled call" : "Missed call",
          color: "text-gray-600",
          bgColor: "bg-gray-50",
          borderColor: "border-gray-200",
          showDuration: false,
        };
      default:
        return {
          icon: CallTypeIcon,
          text: "Call",
          color: "text-gray-600",
          bgColor: "bg-gray-50",
          borderColor: "border-gray-200",
          showDuration: false,
        };
    }
  };

  const statusInfo = getCallStatusInfo();
  const StatusIcon = statusInfo.icon;
  const durationStr = formatDuration(duration);

  const formatTime = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="flex items-center justify-center my-3">
      <div
        className={`flex items-center gap-2.5 px-4 py-2.5 rounded-lg border ${statusInfo.bgColor} ${statusInfo.borderColor}`}
      >
        {/* Call Type Icon */}
        <div className={`${statusInfo.color} flex-shrink-0`}>
          <CallTypeIcon className="text-xl" />
        </div>

        {/* Call Info */}
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <StatusIcon className={`text-base ${statusInfo.color}`} />
            <span className={`text-sm font-medium ${statusInfo.color}`}>
              {statusInfo.text}
            </span>
          </div>

          {/* Duration and Time */}
          <div className="flex items-center gap-2 mt-0.5">
            {statusInfo.showDuration && durationStr && (
              <span className="text-xs text-gray-600 font-medium">
                {durationStr}
              </span>
            )}
            <span className="text-xs text-gray-400">
              {formatTime(createdAt)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallMessage;